import { Flex } from 'foundations-components/components/Flex';
import { FintechOutageBannerWithFetch, ACTION_CONTEXTS
// @ts-expect-error ts-migrate(7016)
} from 'account-and-billing-fintech-outages';
import ActiveQuoteBanner from 'pricing-pages-ui-components/banners/ActiveQuoteBanner';
import PartnerProgramBanner from 'pricing-pages-ui/components/banners/PartnerProgramBanner';
import PromotionBannerContainer from 'pricing-pages-ui/components/banners/PromotionBannerContainer';
import EnvironmentWrapper from 'pricing-pages-ui/components/common/env/EnvironmentWrapper';
import { getHighlightsForProductLine } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { trackBannerInteraction } from '../../v2/utils/tracking/trackingEventUtils';
import { useActiveQuoteBanner } from '../../v2/hooks/banners/useActiveQuoteBanner';
import { getActiveQuoteUrl, handleRedirect } from '../../v2/utils/urls/urls';
import BannerHierarchySection from './BannerHierarchySection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerSection = ({
  productLine,
  screen
}) => {
  const apiNames = productLine ? getHighlightsForProductLine(productLine) : undefined;
  const {
    shouldShowActiveQuoteBanner,
    activeQuotePublicId,
    handleClickClose
  } = useActiveQuoteBanner({
    apiNames,
    skip: !productLine
  });
  const handleClickQuote = () => {
    if (activeQuotePublicId) {
      handleRedirect(getActiveQuoteUrl(activeQuotePublicId));
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    flexDirection: "column",
    inlineSize: "100%",
    rowGap: "400",
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(FintechOutageBannerWithFetch, {
      actionContext: ACTION_CONTEXTS.PURCHASE
    }), /*#__PURE__*/_jsx(PromotionBannerContainer, {}), /*#__PURE__*/_jsx(EnvironmentWrapper, {
      authedNode: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BannerHierarchySection, {
          screen: screen
        }), /*#__PURE__*/_jsx(PartnerProgramBanner, {}), shouldShowActiveQuoteBanner && /*#__PURE__*/_jsx(ActiveQuoteBanner, {
          handleClickQuote: handleClickQuote,
          handleClickClose: handleClickClose,
          trackBannerInteraction: trackBannerInteraction
        })]
      }),
      publicNode: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(BannerHierarchySection, {
          screen: screen
        })
      })
    })]
  });
};
export default BannerSection;